import { QueryCache, QueryClient, MutationCache } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Outlet } from 'react-router-dom';
import { AppToaster } from '../../components/AppToaster';
import { Error as ErrorPage } from '../../components/Error';
import { Login } from '../../components/Login';
import { Navigation } from '../../components/Navigation';
import { VerticalMenu } from '../../components/VerticalMenu';
import styles from './main.module.css';
import { ConfirmDialogProvider } from '../../components/ConfirmDialogProvider/ConfirmDialogProvider';
import { ResolveMarketCountryFromAuth } from '../../components/ResolveMarketCountryFromAuth';
import { DataAccessProvider } from '@axo/shared/data-access/provider';
import { HeartbeatProvider } from '../../components/HeartbeatProvider';
import { EventLogWrapper } from '../../components/EventLogWrapper';
import { ApplicationDataProvider } from '../../store/ApplicationDataProvider';
import { WSSubscriberProvider } from '@axo/shared/feature/web-socket';
import { WSSubscriber } from '../../components/WebSocket';
import { OverlaysProvider } from '@blueprintjs/core';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (
        error instanceof Error &&
        !import.meta.env.PROD &&
        !error.message.includes('Error: 404:')
      ) {
        AppToaster.then((toaster) =>
          toaster.show({
            intent: 'danger',
            message: `${error.message}`,
          }),
        );
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (error instanceof Error) {
        AppToaster.then((toaster) =>
          toaster.show({
            intent: 'danger',
            message: `${error.message}`,
          }),
        );
      }
    },
  }),
});

export function Main() {
  return (
    <DataAccessProvider
      queryClient={queryClient}
      url={{
        api: import.meta.env.VITE_APP_API_URL,
        ws: import.meta.env.VITE_APP_WS_URL,
        integration: import.meta.env.VITE_APP_INTEGRATION_URL,
      }}
    >
      <ApplicationDataProvider>
        <ErrorPage>
          <Login>
            <WSSubscriberProvider>
              <WSSubscriber>
                <ConfirmDialogProvider>
                  <OverlaysProvider>
                    <HeartbeatProvider>
                      <Navigation />
                      <div className={styles.container}>
                        <VerticalMenu />
                        <div className={styles.content}>
                          <ResolveMarketCountryFromAuth>
                            <EventLogWrapper>
                              <Outlet />
                            </EventLogWrapper>
                          </ResolveMarketCountryFromAuth>
                        </div>
                      </div>
                    </HeartbeatProvider>
                  </OverlaysProvider>
                </ConfirmDialogProvider>
              </WSSubscriber>
            </WSSubscriberProvider>
          </Login>
          <ReactQueryDevtools initialIsOpen={false} />
        </ErrorPage>
      </ApplicationDataProvider>
    </DataAccessProvider>
  );
}
